module.exports = __webpack_public_path__ + "static/media/headlights-and-taillights.d653056f.svg";